import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import {getMessageRemindById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import {setFinanceOrderStatus, getFinanceInvoiceContent} from '@/api/financial-center'
import { Loading } from 'element-ui'
// import { get } from '@/api/financial-center'

@Component({})
export default class ResaleInvoiceRemind extends Vue {

    infoData: any = {}
    reviewId: number;
    logShow = true
    withdrawalDialogShow = false // 撤回审批弹框
    reviewIdea = '' // 审批意见
    reviewDialogShow = false // 审批意见弹框
    status: string
    approvalStatus: number = null
    type = ''
    editFileList: { file: string; cnFile: string; isRequired: string }[] = []
    editFiles = {
        projectAllId: null,
        souCoursePrice: null,
        discountPrice: null,
        price: null,
        haveIPQ: null,
        remark: null,
        priceOrRatio: null,
        isCredit: null,
        dissertationType: null,
        contractNo: null,
    }


    isRequired = false

    disBtn = false
    editFileRequired = false
    types = '' // 审批提交还是抄送类型
    addSignShow = false
    transferShow = false
    approvalVisible = false
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    nodeType: string = null //驳回到哪个节点
    // isSync: string = null //重新提交后触发E签宝/易快报
    approvedVisible = false // 审批通过
    approvedData = {
        isReturn: 1
    }
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    backMoneyUrl = ''
    contractUrl = ''
    menuBtn = menuBtn
    formatDate = formatDate
    logList  = []
    fileList = []
    loading = false

    get elImageUrls() {
        return this.infoData ? this.fileList.map(item => item.url): []
    }

    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any) => {
            this.infoData = data.result.messageRemindInfo
            this.backMoneyUrl = this.infoData.backMoneyUrl
            this.contractUrl = this.infoData.contractUrl
            this.logList = data.result.messageRemindInfo.financeRepeatOrderLogList
            this.fileList = [{url: this.infoData.backMoneyUrl, name: '回款凭证'}]
            this.infoData.createdUserRealName = data.result.messageRemindInfo.createdUserRealName
            this.infoData.directorUserRealName = data.result.messageRemindInfo.directorUserRealName

            //  获取开票内容
            const res: any = getFinanceInvoiceContent({companyName: data.result.messageRemindInfo.companyName})
            res.financeInvoiceContent.map(item => {
                if (item.types == this.infoData.content) {
                    this.infoData.content = item.content
                }
            })
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }




    previewContractUrl() {
        window.open(this.contractUrl, 'blank')
    }




    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.status !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }


    // 撤回审批
    async cancelApproval() {
        await setFinanceOrderStatus({ id: this.infoData.id, action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.withdrawalDialogShow = false
    }

    // 驳回审批
    clickRejectButton(status: number) {
        // this.stepNode.approvalStatus = status
        this.approvalStatus = status
        this.approvalVisible = true
    }
    //通过审批
    clickExamineApproveButton(status: number) {
        this.approvalStatus = status
        this.approvedVisible = true
    }

    // 关闭审批意见弹框
    closeReviewDialog() {
        this.reviewIdea = ''
        this.reviewDialogShow = false
    }

    // 审批意见确认
    confirmReviewDialog() {

        const newObj = this.editFiles
        for (const key in newObj) {
            if (!this.editFileList.some(item => item.file === key)) {
                delete newObj[key]
            }
        }
        if(this.isRequired) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.editFileRequired = true
                    break;
                } else {
                    this.editFileRequired = false
                }
            }
        }
        if(this.editFileRequired && this.approvalStatus === 1) {
            this.$message.error('请将编辑的信息填写完整')
            return
        }
        const obj = {
            messageReviewId: this.reviewId,
            status: this.approvalStatus,
            opinion: this.reviewIdea,
            form: this.approvalStatus ? newObj : {},
            nodeType: this.nodeType,

        }
        this.disBtn = true;
        const loading = Loading.service({
            text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
            this.reviewIdea = ''
            this.reviewDialogShow = false
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false;
        })
    }

    approvedConfirm() {

        const newObj = this.editFiles
        for (const key in newObj) {
            if (!this.editFileList.some(item => item.file === key)) {
                delete newObj[key]
            }
        }
        if(this.isRequired) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.editFileRequired = true
                    break;
                } else {
                    this.editFileRequired = false
                }
            }
        }
        if(this.editFileRequired && this.approvalStatus === 1) {
            this.$message.error('请将编辑的信息填写完整')
            return
        }
        const obj = {
            messageReviewId: this.reviewId,
            status: this.approvalStatus,
            opinion: this.reviewIdea,
            form: this.approvalStatus ? newObj : {},
            isRevoke: this.isAgreeRevoke
        }
        this.disBtn = true;
        const loading = Loading.service({
            text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
            this.reviewIdea = ''
            this.reviewDialogShow = false
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false;
        })
    }
//     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
//     doApprovalConfirm(data) {
//         this.nodeType = data.rejectNode
//         this.reviewIdea = data.reviewIdea
//         this.isSync = data.isTouchE
//         this.approvalVisible = false
//         this.confirmReviewDialog()
//     }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.reviewIdea = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }


    /*
    * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }
}
